import { useState } from 'react';
import { apiClient, ValidationResult } from '../service/apiService';

interface UseCodeValidationReturn {
  isValidating: boolean;
  validationResult: ValidationResult | null;
  validationError: string | null;
  validateCode: (code: string, email?: string) => Promise<void>;
  clearValidation: () => void;
}

export function useCodeValidation(): UseCodeValidationReturn {
  const [isValidating, setIsValidating] = useState(false);
  const [validationResult, setValidationResult] = useState<ValidationResult | null>(null);
  const [validationError, setValidationError] = useState<string | null>(null);

  const validateCode = async (code: string, email?: string) => {
    if (!code.trim()) {
      setValidationError('Code is required');
      return;
    }

    setIsValidating(true);
    setValidationError(null);
    setValidationResult(null);

    try {
      const result = await apiClient.validateCode(code.trim(), email?.trim());
      console.log(result)
      setValidationResult(result);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Code validation failed';
      setValidationError(errorMessage);
    } finally {
      setIsValidating(false);
    }
  };

  const clearValidation = () => {
    setIsValidating(false);
    setValidationResult(null);
    setValidationError(null);
  };

  return {
    isValidating,
    validationResult,
    validationError,
    validateCode,
    clearValidation,
  };
}